export default "__VITE_ASSET__e89d2ef6__"